import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useSearchParams } from 'react-router-dom';
export function GeneratingReport() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const product = searchParams.get('product') || 'self';
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    // Animation phases
    const phaseTimer = setInterval(() => {
      setPhase(p => (p + 1) % 4);
    }, 800);
    // Navigate after 4 seconds
    const navigationTimer = setTimeout(() => {
      switch (product) {
        case 'work':
          navigate('/work-mirror/result');
          break;
        case 'relationship':
          const relationshipReportId = `demo-${Date.now()}`;
          navigate(`/report/relationship/${relationshipReportId}?state=preview`);
          break;
        case 'child':
          const childReportId = `demo-${Date.now()}`;
          navigate(`/report/child/${childReportId}?state=preview`);
          break;
        default:
          const reportId = `demo-${Date.now()}`;
          navigate(`/report/${reportId}?state=preview`);
      }
    }, 4000);
    return () => {
      clearInterval(phaseTimer);
      clearTimeout(navigationTimer);
    };
  }, [navigate, product]);
  return <>
      <Helmet data-id="element-1562">
        <title data-id="element-1563">Generating Your Mirror | Lazy Monk Labs</title>
        <meta name="robots" content="noindex, nofollow" data-id="element-1564" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5] flex items-center justify-center px-6 overflow-hidden" data-id="element-1565">
        <div className="max-w-2xl w-full text-center space-y-16" data-id="element-1566">
          {/* Pattern Assembly Animation - Calibration Interface */}
          <div className="relative flex justify-center items-center h-48" data-id="element-1567">
            {/* Background Grid - Subtle coordinate system */}
            <svg className="absolute inset-0 w-full h-full opacity-[0.03]" viewBox="0 0 400 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1568">
              {/* Vertical lines */}
              {Array.from({
              length: 9
            }).map((_, i) => <line key={`v-${i}`} x1={50 + i * 37.5} y1="0" x2={50 + i * 37.5} y2="200" stroke="#F5F5F5" strokeWidth="0.5" data-id="element-1569" />)}
              {/* Horizontal lines */}
              {Array.from({
              length: 5
            }).map((_, i) => <line key={`h-${i}`} x1="0" y1={40 + i * 40} x2="400" y2={40 + i * 40} stroke="#F5F5F5" strokeWidth="0.5" data-id="element-1570" />)}
            </svg>

            {/* Central Pattern Assembly - Elements locking into place */}
            <div className="relative z-10" data-id="element-1571">
              {/* Center anchor point */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-[#64748B] rounded-full" data-id="element-1572" />

              {/* Four elements converging to center - like a diagnostic assembling */}
              {/* Top element */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 w-16 h-0.5 bg-[#64748B] transition-all duration-700 ease-out" style={{
              transform: `translate(-50%, ${phase >= 1 ? '-16px' : '-48px'})`,
              opacity: phase >= 1 ? 1 : 0.3
            }} data-id="element-1573" />

              {/* Right element */}
              <div className="absolute top-1/2 left-1/2 -translate-y-1/2 w-16 h-0.5 bg-[#64748B] transition-all duration-700 ease-out origin-left" style={{
              transform: `translateY(-50%) rotate(90deg) translateX(${phase >= 2 ? '16px' : '48px'})`,
              opacity: phase >= 2 ? 1 : 0.3
            }} data-id="element-1574" />

              {/* Bottom element */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 w-16 h-0.5 bg-[#64748B] transition-all duration-700 ease-out" style={{
              transform: `translate(-50%, ${phase >= 3 ? '16px' : '48px'})`,
              opacity: phase >= 3 ? 1 : 0.3
            }} data-id="element-1575" />

              {/* Left element */}
              <div className="absolute top-1/2 left-1/2 -translate-y-1/2 w-16 h-0.5 bg-[#64748B] transition-all duration-700 ease-out origin-left" style={{
              transform: `translateY(-50%) rotate(90deg) translateX(${phase >= 4 ? '-16px' : '-48px'})`,
              opacity: phase >= 4 ? 1 : 0.3
            }} data-id="element-1576" />

              {/* Outer frame - locks in at final phase */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 border border-[#2B2B2B] transition-all duration-700" style={{
              opacity: phase >= 3 ? 0.5 : 0,
              transform: `translate(-50%, -50%) scale(${phase >= 3 ? 1 : 0.8})`
            }} data-id="element-1577" />
            </div>
          </div>

          {/* Text */}
          <div className="space-y-4" data-id="element-1578">
            <h1 className="text-2xl md:text-3xl font-light text-[#F5F5F5]" data-id="element-1579">
              Generating your mirror…
            </h1>
            <p className="text-sm text-gray-600 font-mono" data-id="element-1580">
              Mapping your work pattern
            </p>
          </div>
        </div>
      </div>
    </>;
}